import React from 'react'

export const Typography = () => {

  return (
    <div className='example-container'>
      <div className='typography-container'>
        <div className='table-row'>
          <div className='cell'></div>
          <div className='col-title cell'><h3>Font Size</h3></div>
          <div className='col-title cell'><h3>Line Height</h3></div>
          <div className='col-title cell'><h3>Color</h3></div>
          <div className='col-title cell'><h3>Letter Spacing</h3></div>
          {/*}<div className='col-title cell'><h3>Font Size</h3></div>
          <div className='col-title cell'><h3>Line Height</h3></div>
          <div className='col-title cell'><h3>Letter Spacing</h3></div>
          <div className='col-title cell'><h3>Font Size</h3></div>
          <div className='col-title cell'><h3>Line Height</h3></div>*/}
        </div>
        <div className='table-row'>
          <div className='cell'><h1>h1</h1></div>
          <div className='cell'><h1>40px</h1></div>
          <div className='cell'><h1>50px</h1></div>
          <div className='cell'><h1>$title</h1></div>
          <div className='cell'><h1>0</h1></div>
          {/*<div className='cell'><h1>34px</h1></div>
          <div className='cell'><h1>44px</h1></div>
          <div className='cell'><h1>-0.3px</h1></div>
          <div className='cell'><h1>28px</h1></div>
          <div className='cell'><h1>38px</h1></div>*/}
        </div>
        <div className='table-row'>
          <div className='cell'><h2>h2</h2></div>
          <div className='cell'><h2>28px</h2></div>
          <div className='cell'><h2>40px</h2></div>
          <div className='cell'><h2>$text</h2></div>
          <div className='cell'><h2>0</h2></div>
        </div>
        <div className='table-row'>
          <div className='cell'><h3>h3</h3></div>
          <div className='cell'><h3>18px</h3></div>
          <div className='cell'><h3>28px</h3></div>
          <div className='cell'><h3>$text</h3></div>
          <div className='cell'><h3>0</h3></div>
        </div>
        <div className='table-row'>
          <div className='cell'><p>p, li</p></div>
          <div className='cell'><p>16px</p></div>
          <div className='cell'><p>26px</p></div>
          <div className='cell'><p>$text</p></div>
          <div className='cell'><p>0</p></div>
        </div>
        <div className='table-row'>
          <div className='cell'><p>a</p></div>
          <div className='cell'><p>16px</p></div>
          <div className='cell'><p>26px</p></div>
          <div className='cell'><p className="purple_popsicle">$purple-popsicle</p></div>
          <div className='cell'><p>0</p></div>
        </div>
      </div>
    </div>
  )
}
